module.exports = __webpack_public_path__ + "img/INSIGHTS (8).7f006c85.png";